import axios from '@/libs/axios'

const fishermanActions = {
    fetchFishermen({commit, dispatch}, searchParams) {
        return axios.get('/fishermen', {params: searchParams})
    },
    fetchFishermenList({commit, dispatch}, searchParams) {
        return axios.get('/fishermen/list', {params: searchParams})
    },
    exportFishermenList({commit, dispatch}, searchParams) {
        return axios.get('/fishermen/export', {params: searchParams, responseType: 'blob'})
    },
    downloadFishermanImportSample() {
        return axios.post('/imports/fishermen/download-sample', [], {responseType: 'blob'})
    },
    getFishermanImportValidationRules() {
        return axios.post('/imports/fishermen/validation-rules')
    },
    loadFishermanImportPreview({commit, dispatch}, data) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        };

        return axios.post('/imports/fishermen/load-preview', data, config)
    },
    fishermanImport({commit, dispatch}, data) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        };

        return axios.post('/imports/fishermen/import', data, config)
    },
    fetchFishermenForSelect({commit, dispatch}, searchParams) {
        return new Promise((resolve, reject) => {
            dispatch('fetchFishermenList', searchParams)
                .then(response => {
                    const list = []

                    if (response.data.entities) {
                        for (const key in response.data.entities) {
                            let cardNumber = '-'
                            if (response.data.entities[key].fishing_card_number) {
                                cardNumber = response.data.entities[key].fishing_card_number
                            }

                            list.push({
                                value: parseInt(response.data.entities[key].id),
                                title: response.data.entities[key].name + ' (' + cardNumber + ')',
                            })
                        }
                    }

                    resolve(list)
                }).catch(error => {
                reject(error)
            })
        })
    },
    fetchNationalitiesForSelect() {
        return new Promise((resolve, reject) => {
            axios.get('/fishermen/nationalities/list')
                .then(response => {

                    let nationalities = require("i18n-iso-countries")
                    nationalities.registerLocale(require("i18n-iso-countries/langs/hu.json"));

                    const list = []

                    if (response.data.values) {
                        for (const key in response.data.values) {
                            if (response.data.values[key].value === 'UNKNOWN') {
                                list.push({
                                    value: response.data.values[key].value,
                                    title: 'Ismeretlen',
                                })
                            } else {
                                list.push({
                                    value: response.data.values[key].value,
                                    title: nationalities.getName(response.data.values[key].title, "hu"),
                                })
                            }
                        }
                    }

                    resolve(list)
                }).catch(error => {
                reject(error)
            })
        })
    },
    fetchGendersForSelect() {
        return new Promise((resolve, reject) => {
            axios.get('/fishermen/genders/list')
                .then(response => {
                    const list = []

                    if (response.data.values) {
                        for (const key in response.data.values) {
                            list.push({
                                value: response.data.values[key].value,
                                title: response.data.values[key].title,
                            })
                        }
                    }

                    resolve(list)
                }).catch(error => {
                reject(error)
            })
        })
    },
    fetchFisherman({commit, dispatch}, id) {
        return axios.get(`/fishermen/${id}`)
    },
    storeFisherman({commit, dispatch}, data) {
        return axios.post('/fishermen', data)
    },
    updateFisherman({commit, dispatch}, data) {
        return axios.put(`/fishermen/${data.id}`, data)
    },
    deleteFisherman({commit, dispatch}, id) {
        return axios.delete(`/fishermen/${id}`)
    },
}

export default fishermanActions
